module.exports = __webpack_public_path__ + "8419d2aae0d55647e7824879684f21da.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./src/system/assets/css/fonts/itcavantgardestd-bk-webfont.ttf
 ** module id = 372
 ** module chunks = 0
 **/